import React, { useState } from "react";
import CommonButton from "../../../Components/global-components/CommonButton/CommonButton";
import CommonDropDown from "../../../Components/global-components/CommonDropDown/CommonDropDown";
import BannerImage from "../../../Components/login-components/banner-image/BannerImage";
import BottomCard from "../../../Components/login-components/bottom-card/BottomCard";
import LogoContainer from "../../../Components/login-components/logo-container/LogoContainer";
import ErrorBottomDrawer from "../../../Components/global-components/ErrorBottomDrawer/ErrorBottomDrawer"

import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Annual.module.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Tab from "../../../Components/kyc-components/Tab";
import { useEffect } from "react";
import MsHome from "../../../Components/Maruti-Suzuki-components/MsHome";
import { activeStepper } from "../../Redux/stepperSlice";
import { gaFunction, scrollIntoViewFunc } from "../../../Router";
import { TextField } from "@mui/material";
import {clearFormSixtyDataState} from "../../Redux/digitalFormSixtySlice";
import Individual from "../../Edd/Individual_Edd";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import TextInput from "../../../Components/global-components/CommonTextInput/TextInput";

const options = {
  option1: [
    "Select",
    "0-2.5 lacs",
    "2.5-5 lacs",
    "5-15 lacs",
    "15-20 lacs",
    "20-30 lacs",
    "30+ lacs",
  ],
  option2: [
    "Select",
    "Salaried",
    "Professional",
    "Self Employed",
    "Student",
    "Home maker",
    "Other",
  ],
  option3: [
    "Select",
    "Government",
    "Private Limited",
    "Public Limited",
    "Trust",
    "Other",
  ],
  option4: ["Select", "Yes", "No", "Related to one"],
  option5: [
    "Select",
    "Blindness",
    "Low Vision",
    "Hearing Impairment",
    "Locomotor Disability",
    "Leprosy Cured",
    "Cerebral Palsy",
    "Intellectual Disability",
    "Mental Illness",
    "Muscular Dystrophy",
    "Parkinson's Disease",
    "Acid Attack Victim",
    "Sickle Cell Disease",
    "Hemophilia",
    "Thalassemia",
    "Speech and Language Disability",
    "Multiple Sclerosis",
    "Specific Learning Disabilities",
    "Chronic Neurological Conditions",
    "Autism Spectrum Disorder",
    "Dwarfism",
  ],
  citizenshipOption: [
    "Select",
    "Resident",
    "Non-Resident"
  ],
  nationalityOption: [
    "Select",
    "Indian",
    "Other"
  ],
};

const AnnualIncome = () => {
  const [txnDupeError, setTxnDupeError] = useState(false) 
  const [annualIncome, setAnnaulIncome] = useState("");
  const [error, setError] = useState("");
  const [occupation, setOccupation] = useState("");
  const [organization, setOrganization] = useState("");
  const [citizenship, setCitizenship] = useState("");
  const [nationality, setNationality] = useState("");
  const [nationalityOther, setNationalityOther] = useState("");
  const [political, setPolitical] = useState("");
  const [occupationOther, setOccupationOther] = useState("");
  const [organizationOther, setOrganizationOther] = useState("");
  let { phoneNumber } = useSelector((state) => state.userDetails.userData);
  const Is_IDV3 = useSelector((state) => state.kycDetails.Is_IDV3);
  let {
    gender,
    maritalStatus,
    mothersName,
    fatherName,
    correspondenceAddress,
    correspondenceState,
    correspondenceCity,
    correspondencePincode,
    userEditedName,
    userEditedAddress,
    permanentAddress,
    permanentCity,
    permanentDistrict,
    permanentCountry,
    permanentState,
    permanentPincode,
    name,
    manualKYC,
    dob,
    criminalProceedings,
    isHighNetworthIndividual,
    sourceOfFund,
    incomeProof,
    purposeNatureBusinessConnection,
    publicInfo,
  } = useSelector((state) => state.userDetails.customerData);
  
  const userPanNumber = useSelector((state) => state.panDetails.userPanNumber);
  const { mi_u, channelUrl,subChannel } = useSelector(
    (state) => state.partnerChannelNameSlice.marutiUserDetails
  );
  const kycRefId = useSelector((state) => state.uploadedFile.kycRefId);
  const kycId = useSelector((state) => state.kycDetails.kycRefIdAddNewKyc);
  const { dob:dobOVD, fatherName: fatherNameOVD } = useSelector(
    (state) => state.uploadedFile.previewDocumentDetail
  );
  const digitalFormSixtyID= useSelector((state) => state.digitalFormSixty.formSixtyData.digitalForm60Id);
  const { state } = useLocation();
  const { isRouteAllowed, type, typeOfDoc } = state || {};

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // remove on production
  if (Object.keys(phoneNumber).length === 0)
    phoneNumber = localStorage.getItem("mobileNumber");

    {
      /* -------START------NEW FEATURE OF DISABILITY */
    }
    const [disabilityRadioValue, setDisabilityRadioValue] = useState("No");
    const [UDIDNumber, setUDIDNumber] = useState("");
    const [percentage, setPercentage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [disabilityDropdownValues, setDisabilityDropdownValues] = useState("");
  
    const disabilityRadioValueHandleChange = (e) => {
      setDisabilityRadioValue(e.target.value);
    };
  
    const validateUDIDNumber = (value) => {
      let regexPan = /[A-Z]{2}\d{16}/i;
      // let regexPan = /^[A-Z]{2}[0-9]{16}$/i;
      value = value?.replace(/\s/g, "");
      if (value.length <= 18) {
        setUDIDNumber(value);
      }
      setErrorMessage(null);
      if (!regexPan.test(value)) {
        setErrorMessage("Enter valid UDID Number.");
      }
    };
  
    const validatePercentage = (e) => {
      const value = e.target.value.trim();
      const regex = /^\d+$/;
  
      if (regex.test(value)) {
        const num = parseInt(value, 10);
        if (num <= 100) {
          setPercentage(num);
          setErrorMessage(""); // ✅ no error
        } else if (num > 100) {
          setPercentage("");
          setErrorMessage("Number must be less than 100");
        } else {
          setPercentage("");
          setErrorMessage("Number must be greater than 1");
        }
      } else {
        setPercentage("");
        setErrorMessage("Percentage shold be only numbers");
      }
    };
  
    {
      /* -------END------NEW FEATURE OF DISABILITY */
    }

    const onClickHandler = () => {
      gaFunction("Income", "Income Proceed Clicked");
      let data;
      let userData;
      let disabilitiesData;
  
      if (
        annualIncome !== "" &&
        occupation !== "" &&
        organization !== "" &&
        citizenship !== "" &&
        nationality !== "" &&
        political !== ""
      ) {
        if (
          (occupation === "Other" && !occupationOther) ||
          (organization === "Other" && !organizationOther) ||
          (nationality === "Other" && !nationalityOther)
        ) {
          setError("Please fill up the given form");
          setTimeout(() => {
            scrollIntoViewFunc("incomeError");
          }, 1);
          return;
        }
  
        userData = {
          // mobile: phoneNumber,
          pan: userPanNumber,
          annualIncome: annualIncome,
          occupation:
            occupation === "Other"
              ? `${occupation} - ${occupationOther}`
              : occupation,
          organizationType:
            organization === "Other"
              ? `${organization} - ${organizationOther}`
              : organization,
          citizenship: citizenship,
          nationality:
            nationality === "Other"
              ? `${nationality} - ${nationalityOther}`
              : nationality,
          isPoliticallyExposed:
            political === "Yes" || political === "Related to one" ? true : false,
          gender: gender,
          maritalStatus: maritalStatus,
          mothersName: mothersName,
          correspondenceAddress: correspondenceAddress,
          correspondenceState: correspondenceState,
          correspondenceCity: correspondenceCity,
          correspondencePincode: correspondencePincode,
          type,
          userEditedName,
          userEditedAddress,
          permanentCity,
          permanentDistrict,
          permanentCountry,
          permanentState,
          permanentPincode,
          permanentAddress,
          name,
          // mi_identifier: mi_u,
          channel: channelUrl,
          subChannel,
          txnId: mi_u,
          kycId,
          dob: dob || dobOVD || "",
          fatherName: fatherName || fatherNameOVD || "",
          manualKYC,
          digitalFormSixtyID: digitalFormSixtyID || "",
        };
  
        if (disabilityRadioValue == "Yes") {
  
          if (
            percentage == "" ||
            UDIDNumber == "" ||
            disabilityDropdownValues == ""
          ) {
            setErrorMessage("Please fill all required fields.");
            return;
          }
  
          if (disabilityDropdownValues == "") {
            setErrorMessage("Please select type of impairment..");
            return;
          }
          if (percentage == "") {
            setErrorMessage("Please enter Percentage of Disability.");
            return;
          }
          if (UDIDNumber?.length < 18 || errorMessage) {
            setErrorMessage("Please enter valid UDID number.");
            return;
          }
  
          disabilitiesData = {
            differentlyAbledStatus: true,
            typeOfImpairment: disabilityDropdownValues,
            percentageOfImpairment: percentage,
            UDIDNumber: UDIDNumber,
          };
          data = { ...userData, ...disabilitiesData };
          // }
        }
  
        if (disabilityRadioValue == "No") {
          disabilitiesData = {
            differentlyAbledStatus: false,
            typeOfImpairment: "",
            percentageOfImpairment: "",
            UDIDNumber: "",
          };
          data = { ...userData, ...disabilitiesData };
        }
  
        // console.log("get some noise", data);
        data = JSON.stringify(data);
  
        // https://ctrln-uat.hdfcergo.com
        let config = {
          method: "patch",
          url: `${process.env.REACT_APP_BASE_URL}/customer/customer-kyc`,
          headers: {
            "Content-Type": "application/json",
            txnId: localStorage.getItem("txnId") === "null" ?? null,
            // token: localStorage.getItem("token"),
          },
          data: data,
        };
  
        axios(config)
          .then(function (response) {
            if (response.data.success === true) {
              dispatch(clearFormSixtyDataState());
              dispatch(activeStepper(3));
              navigate("/Success", {
                state: {
                  kyc_ref_id: response?.data?.data?.kyc_id,
                  successUrl: response?.data?.data?.success_url,
                  typeOfKyc: typeOfDoc,
                },
              });
            }
          })
          .catch(function (error) {
            if (
              error?.response?.data?.message == "Duplicate transaction id found"
            ) {
              setTxnDupeError(true);
            }
          });
      } else {
        setError("Please fill up the given form");
        setTimeout(() => {
          scrollIntoViewFunc("incomeError");
        }, 1);
      }
    };


  useEffect(() => {
    if (!state) navigate("/login");
  }, [navigate, state]);

  useEffect(() => {
    // disable browser button
    return () => {
      setTimeout(() => {
        window.history.forward();
      }, 0);
    };
  }, []);
  return (
    <>
      {isRouteAllowed && (
        <div className={styles.AnnualIncome}>
          <MsHome>
            <BannerImage>
              {/* <MdKeyboardBackspace
              size={30}
              style={{ margin: 20 }}
              onClick={backHandler}
            /> */}
              <LogoContainer />
            </BannerImage>
            <BottomCard max>
              {Is_IDV3 ? <Individual /> :
                (
                  <div className="md:h-full">
                    <div className="hidden md:block md:h-[22%]">
                      <div className="p-[10px] md:p-0"></div>
                      <label className="md:text-xl">
                        <b>KYC Document</b>
                      </label>
                      <p className="hidden md:block md:text-sm">
                        let's fetch your kyc details using
                      </p>
                      <div className="p-[10px] md:p-[6px]"></div>
                      {/* <div className="md:w-[50%] md:mb-0">
                    <Tab isDisabled />
                  </div> */}
                    </div>
                    <div className="md:w-[70%]  md:h-[78%] md:p-[10px_0_0_0]">
                      <div className="overflow-scroll p-2 md:p-0  md:h-[80%]">
                        <CommonDropDown
                          options={options.option1}
                          selected={annualIncome}
                          setSelected={setAnnaulIncome}
                          label={"Annual Income"}
                        />
                        <CommonDropDown
                          options={options.option2}
                          selected={occupation}
                          setSelected={setOccupation}
                          label={"Occupation"}
                        />
                        {occupation === "Other" && (
                          <TextField
                            fullWidth
                            size="small"
                            sx={{ marginTop: 1, marginBottom: 1 }}
                            placeholder="Please specify other"
                            onChange={(e) => setOccupationOther(e.target.value)}
                          />
                        )}
                        <CommonDropDown
                          options={options.option3}
                          selected={organization}
                          setSelected={setOrganization}
                          label={"Organization Type"}
                        />
                        {organization === "Other" && (
                          <TextField
                            fullWidth
                            size="small"
                            sx={{ marginTop: 1, marginBottom: 1 }}
                            placeholder="Please specify other"
                            onChange={(e) => setOrganizationOther(e.target.value)}
                          />
                        )}
                        <CommonDropDown
                          options={options?.citizenshipOption}
                          selected={citizenship}
                          setSelected={setCitizenship}
                          label={"Citizenship"}
                        />
                        <CommonDropDown
                          options={options?.nationalityOption}
                          selected={nationality}
                          setSelected={setNationality}
                          label={"Nationality"}
                        />

                        {nationality === "Other" && (
                          <TextField
                            fullWidth
                            size="small"
                            sx={{ marginTop: 1, marginBottom: 1 }}
                            placeholder="Please specify other"
                            onChange={(e) => setNationalityOther(e.target.value)}
                          />
                        )}
                        <CommonDropDown
                          options={options.option4}
                          selected={political}
                          setSelected={setPolitical}
                          label={"Are you a Politically Exposed Person(PEP) or family member/ close relative / associate of PEP"}
                        />
                        <p className="text-red-500 text-sm" id="incomeError">
                          {error && error}
                        </p>
                        <i
                          className="text-xs font-medium text-black"
                        >
                          "Politically Exposed Persons" (PEPs) are individuals who have been entrusted with prominent public functions by a foreign country, including the heads of States or Governments, senior politicians, senior government or judicial or military officers, senior executives of state-owned corporations and important political party officials.
                        </i>
                        {/* <div className="h-1/3"></div> */}
                       {/* -------START------NEW FEATURE OF DISABILITY */}
                      <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <label
                            className="block text-sm font-medium "
                            style={{ marginRight: "30px" }}
                          >
                            Are you a person with disability :
                          </label>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={disabilityRadioValue}
                            onChange={disabilityRadioValueHandleChange}
                          >
                            <FormControlLabel
                              value="Yes"
                              control={
                                <Radio
                                  sx={{
                                    "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                                      {
                                        color: "#E42125",
                                      },
                                    "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                                      color: "#E42125",
                                    },
                                  }}
                                />
                              }
                              label="Yes"
                            />
                            <FormControlLabel
                              value="No"
                              control={
                                <Radio
                                  sx={{
                                    "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                                      {
                                        color: "#E42125",
                                      },
                                    "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                                      color: "#E42125",
                                    },
                                  }}
                                />
                              }
                              label="No"
                            />
                          </RadioGroup>
                        </div>
                        {disabilityRadioValue === "Yes" && (
                          <>
                            <CommonDropDown
                              AsteriskStar
                              options={options.option5}
                              selected={disabilityDropdownValues}
                              setSelected={setDisabilityDropdownValues}
                              label={
                                "Type of Impairment (as per UDID classification)"
                              }
                            />
                            {/* <CommonMultivaluesDropDown
                              AsteriskStar
                              label={
                                "Type of Impairment (as per UDID classification)"
                              }
                              disabilityDropdownValues={
                                disabilityDropdownValues
                              }
                              setDisabilityDropdownValues={
                                setDisabilityDropdownValues
                              }
                            /> */}
                            <div className={styles["form-container"]}>
                              <div className="md:w-[100%]">
                                <div className="mt-2"></div>
                                <TextInput
                                  id={"percentageField"}
                                  label={
                                    "Percentage of Disability (as certified)"
                                  }
                                  value={percentage}
                                  AsteriskStar
                                  placeholder={"XXX %"}
                                  onChange={(e) => validatePercentage(e)}
                                  type="text"
                                />
                                <div className="mt-4"></div>
                                <TextInput
                                  id={"UDIDNumberField"}
                                  label={"Enter your UDID Number"}
                                  value={UDIDNumber}
                                  type="text"
                                  AsteriskStar
                                  placeholder={"Eg. AB 0000 1111 2222 3333"}
                                  onChange={(e) =>
                                    validateUDIDNumber(
                                      e.target.value.toUpperCase()
                                    )
                                  }
                                />

                                {errorMessage && (
                                  <p className="text-red-500 mt-3">
                                    {errorMessage}
                                  </p>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      </>
                      {/* -------END------NEW FEATURE OF DISABILITY */}

                      </div>
                      <div className="w-full mt-7 md:w-[235px] md:mt-[2px] mb-4 md:mb-0 md:h-[20%]">
                        <CommonButton
                          label="Proceed"
                          filled
                          arrow
                          id={"incomeProcess"}
                          onClickHandler={onClickHandler}
                        />
                      </div>
                    </div>
                  </div>
                )
              }
            </BottomCard>
          </MsHome>
          {txnDupeError && (
                  <ErrorBottomDrawer
                    extraNotes="Error"
                    errorMessage="Duplicate transaction id found"
                    onClickHandler={() => setTxnDupeError(false)}
                  />
                )}
        </div>
      )}
    </>
  );
};

export default AnnualIncome;
